export default __webpack_public_path__ + "static/media/257.b25ecab2.jpg";